import { helpers } from 'vuelidate/lib/validators'

const phoneValidator = helpers.regex('phoneValidator', /^(\+?\(?[0-9]{2,3}\)?[-\s]?)?\(?[0-9]{2,4}\)?[-\s]?[0-9]{4,10}$/i)
const cuitValidator = helpers.regex('cuitValidator', /^[0-9]{11}$/)

export { phoneValidator, cuitValidator }



// WEBPACK FOOTER //
// ./src/util/validators.js